class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notification.parentNode.parentNode.classList.add('active');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.notification.parentNode.parentNode.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    const cartNotificationProducts = document.querySelectorAll('.js-cart-notification-product');

    if (!!(cartNotificationProducts) && cartNotificationProducts.length > 0) {
      cartNotificationProducts.forEach((cartNotificationProduct) => {
        cartNotificationProduct.remove();
      });
    }

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (parsedState.hasOwnProperty('items') && parsedState.items.length > 0) {
      const sections = [];
      let sectionHTML = ``;

      parsedState.items.forEach((item) => {
        this.productId = item.id;
        this.getSectionsToRender().forEach((section => {
          if (section.id == 'cart-notification-products') {
            sections.push(this.getSectionInnerHTML(parsedState.sections[section.id], section.selector));
          } else {
            document.getElementById(section.id).innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          }
        }));
      });

      sections.forEach((section) => {
        sectionHTML += `<div class="cart-notification-product js-cart-notification-product">${section}</div>`;
      });

      document.getElementById('cart-notification-products').insertAdjacentHTML('afterend', sectionHTML);
    } else {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
    }

    this.header?.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-products',
        selector: `#cart-notification-product-${this.productId}`,
      },
      /*{
        id: 'cart-notification-button'
      },*/
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      const notificationProducts = document.querySelectorAll('.js-cart-notification-product');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
      
      if (!!(notificationProducts) && notificationProducts.length > 0) {
        notificationProducts.forEach((notificationProduct) => {
          notificationProduct.remove();
        });
      }
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

var bagText = document.getElementById('bag-button');
var miniCart = document.querySelectorAll('.mini-cart-container, .mini-cart-overlay');
bagText?.addEventListener('click', function (e) {
  e.preventDefault();
  for (var i = 0; i < miniCart.length; i++){
    miniCart[i].style.visibility = 'visible';
    miniCart[i].style.opacity = 1;
  }
});
